import Skeleton from '@/src/components/skeleton/Skeleton'
import React from 'react'

const IntegrationLargeSkeleton = () => {
  return (
    <div className={'c-integration c-integration--large-variation '}>
      <div className="c-integration__header">
        <div className="c-integration__logo">
          <Skeleton width={'130px'} height={'80px'} />
        </div>
        <div className="c-integration__title">
          <Skeleton width={'100%'} height={'16px'} />
        </div>
      </div>
      <Skeleton width={'100%'} height={'32px'} />
    </div>
  )
}

export default IntegrationLargeSkeleton
